// client/src/pages/Assessment.tsx

import React, { useState, useEffect } from "react";
import { getAssessmentQuestions } from "../services/learningService";
import "../assets/styles/pages.css";

interface Question {
  id: string;
  question: string;
  options: string[];
}

const Assessment: React.FC = () => {
  const [questions, setQuestions] = useState<Question[]>([]);
  const [loading, setLoading] = useState<boolean>(false);
  const [error, setError] = useState<string | null>(null);

  useEffect(() => {
    const fetchQuestions = async () => {
      setLoading(true);
      try {
        const data = await getAssessmentQuestions();
        setQuestions(data);
      } catch (err: any) {
        setError(err.message);
      } finally {
        setLoading(false);
      }
    };

    fetchQuestions();
  }, []);

  return (
    <div className="page assessment-page">
      <h2>Assessment</h2>
      {loading ? (
        <p>Loading assessment questions...</p>
      ) : error ? (
        <p style={{ color: "red" }}>{error}</p>
      ) : (
        <ul>
          {questions.map((q) => (
            <li key={q.id}>
              <p>{q.question}</p>
              <ul>
                {q.options.map((option, idx) => (
                  <li key={idx}>{option}</li>
                ))}
              </ul>
            </li>
          ))}
        </ul>
      )}
    </div>
  );
};

export default Assessment;
